<template>
  <div class="box">
    <div class="mod4 flex-row">
      <span class="secondary-title" style="margin:0">上传实物信息表</span>
      <span class="txt" @click="downloadGoodsInfoSheet">下载实物信息表</span>
    </div>
    <div v-for="(item,index) in orderMaterialInfo.orderMaterial" :key="index">
      <div class="goods-info-sheet">
        <div class="sheet-content">
          <label class="label-checkbox item-content" @click="getChange(item.orderMaterialDetail)">
            <input type="checkbox" v-model="item.orderMaterial.isChecked" :value="item.orderMaterial.orderMaterialId" :disabled="isDisabled(item)">
            <div class="item-media group">
              <i class="icon icon-form-checkbox i-style" style="margin-top:10px;width:20px;height:20px;"></i>
            </div>
          </label>
          <div style="margin-top: 5px; margin-left: 15px;">
            <display-icon-and-status :materialType = item.orderMaterial.materialType :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON"></display-icon-and-status>
          </div>
          <div class="outer1 flex-col">
            <span class="word2">{{ item.orderMaterial.materialDesc }}</span>
            <span class="txt4">用于{{ item.orderMaterial.euName }}</span>
          </div>
          <div v-if="item.orderMaterialDetail && item.orderMaterialDetail.fileName">
            <img class="label2" :src="emkt.getOrderMaterialFileShowIcon(item.orderMaterialDetail.fileName)"/>
            <img v-show="!disAllowUploadOrDelete(item)" class="icon5" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/删除.svg'" @click="removeFile(item)"/>
          </div>
          <div v-else class="upload">
            <img class="upload-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/上传.svg'"/>
            <input type="file" @change="uploadFile($event, item)" class="uplaod-input">
            <span class="upload-word">上传文档</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mod6">
      <span class="info2">
        请勾选您本次寄出的物品，务必完整填写《实物信息表》全部相关信息，将文档直接上传。推荐在电脑端使用小程序完成上传操作。
      </span>
      <span class="txt" @click="showMiniProgramInComputerUsage">查看小程序在电脑端的使用方法</span>
    </div>
    <span class="secondary-title">寄出快递</span>
    <div class="address">
      <div class="wrap flex-col">
        <div class="box7 flex-row">
          <img class="icon9" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/地址.svg'"/>
          <span class="address-content">{{ emkt.DELIVERY_ADDRESS.ADDRESS }}</span>
          <button class="group2 flex-col" :data-clipboard-text="'收件人姓名：' + emkt.DELIVERY_ADDRESS.RECEIVER + '\n电话：' + emkt.DELIVERY_ADDRESS.PHONE + '\n地址信息：' + emkt.DELIVERY_ADDRESS.ADDRESS" @click="copy" id="tag-copy">
            <span class="tag">复制</span>
          </button>
        </div>
        <div class="box8 flex-row">
          <span class="info4">{{ emkt.DELIVERY_ADDRESS.RECEIVER }}</span>
          <span class="info4">{{ emkt.DELIVERY_ADDRESS.PHONE }}</span>
        </div>
        <div class="line flex-col"></div>
        <div class="box10 flex-row">
          <img class="outer4" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/顺丰logo.svg'"/>
          <span class="paragraph1">
            打开顺丰小程序
            <br />
            选择货到付款，快捷寄件
          </span>
          <div class="delivery-icon flex-col"><span class="tag" @click="openShunFengProgram">打开</span></div>
        </div>
      </div>
      <img class="delivery flex-col" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/express.png'"/>
    </div>
    <div class="btn-group">
      <van-row>
        <van-col :span="24 / expressCategoryList.length" v-for="(item, index) in expressCategoryList" :key="index">
          <van-button round size="small" block :plain="plain[index]" @click="onChange(index)" color="#5878FA" class="express-category">{{item}}</van-button>
        </van-col>
      </van-row>
    </div>
    <div v-if="plain[0]">
      <span class="secondary-title">填写快递单号</span>
      <ul class="express-block">
        <li class="express-content" v-for="(express,index) in expressList" @click="chooseExpress(express,index)" :class="{'active':index === expressIndex}" >
          <img class="icon-express" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'express/' + express + '.png'">
          <span class="express-font">{{express}}</span>
        </li>
      </ul>
      <div class="block9 flex-col">
        <div class="bd4 flex-col">
          <input class="word19" v-model.trim="expressNo" type="text" placeholder="请输入快递单号" ref="content">
        </div>
      </div>
    </div>
    <div style="color: #D2D2D6; text-align: center;pointer-events:none;">
      <p style="font-size: 12px; margin-bottom: 50%;">---我是有底线的---</p>
    </div>
    <div class="footer">
      <div class="footer-content">
        <div class="save-btn" @click="saveSampleDelivery"><span class="save-tag">保存</span></div>
      </div>
    </div>
  </div>
</template>
<script>
  import Clipboard from 'clipboard'
  import EMKT from '../../emkt'
  import wx from 'wx'
  import DisplayIconAndStatus from './DisplayIconAndStatus'
  import {mapState, mapGetters} from 'vuex'

  export default {
    name: 'AddSampleDeliverySheet',
    components: {DisplayIconAndStatus},
    computed: {
      ...mapState(['sessionInfo']),
      ...mapGetters(['getOrderMaterialInfo', 'getReassembleOrderMaterialInfo']),
      customerNo () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo
      },
      customerName () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerName
      },
      currentOrderMaterialExpressId () {
        if (this.orderMaterialInfo.expressInfo) {
          return this.orderMaterialInfo.expressInfo.orderMaterialExpressId
        } else if (this.uploadAfterOrderMaterialExpressId !== null) {
          return this.uploadAfterOrderMaterialExpressId
        }
      }
    },
    created () {
      this.fetchData()
    },
    activated () {
      this.fetchData()
    },
    data () {
      return {
        orderMaterialInfo: {},
        plain: [true, false],
        expressNo: null,
        expressCategoryList: ['快递寄送', '非快递寄送'],
        expressIndex: 0,  // 初始化第一个快递高亮
        expressName: '顺丰快递',
        expressList: ['顺丰快递', '京东快递', '中通快递', '申通快递', '百世快递', '邮政EMS', '德邦快递', '圆通快递', '韵达快递', '其他快递'],
        sampleInfoFiles: [],
        fromType: null,
        uploadAfterOrderMaterialExpressId: null
      }
    },
    methods: {
      fetchData () {
        var _this = this
        _this.orderMaterialInfo = this.getReassembleOrderMaterialInfo
        _this.fromType = this.$route.params.fromType
        // 默认勾选有orderMaterialDetailId的数据，绑定快递信息
        _this.setIsCheckedOrderMaterial(_this.orderMaterialInfo)
        // 绑定快递信息
        _this.setExpressInfo(_this.orderMaterialInfo)
      },
      setIsCheckedOrderMaterial (orderMaterialInfo) {
        orderMaterialInfo.orderMaterial.forEach(material => {
          if (material.orderMaterialDetail !== undefined) {
            if (material.orderMaterialDetail.orderMaterialDetailId !== undefined) {
              material.orderMaterial.isChecked = true
            }
          }
        })
      },
      setExpressInfo (orderMaterialInfo) {
        if (this.fromType === EMKT.SAMPLE_DELIVERY_FORM_TYPE.fromAddSampleDelivery) {
          this.expressNo = null
          this.expressIndex = 0
          this.plain = [true, false]
        } else if (this.fromType === EMKT.SAMPLE_DELIVERY_FORM_TYPE.fromModifySampleDelivery) {
          if (orderMaterialInfo.expressInfo) {
            this.expressNo = orderMaterialInfo.expressInfo.expressNo
            if (this.orderMaterialInfo.expressInfo.expressName === '') this.expressIndex = 0
            else if (this.orderMaterialInfo.expressInfo.expressName === '非快递寄送') {
              this.plain = [false, true]
              this.expressIndex = 0
              this.expressNo = null
            } else {
              this.plain = [true, false]
              this.expressList.forEach((express, index) => {
                if (express === this.orderMaterialInfo.expressInfo.expressName) {
                  this.expressIndex = index
                }
              })
            }
          }
        }
      },
      downloadGoodsInfoSheet () {
        let sampleInfoFiles = this.orderMaterialInfo.initFileList.filter(initFile => initFile.fileType === EMKT.MATERIAL_FILETYPE.SAMPLE_INFO_SHEET)
        this.$router.push({
          name: 'DownloadArticleInfoSheet',
          params: {sampleInfoFiles: sampleInfoFiles}
        })
      },
      isDisabled (value) {
        if (value.orderMaterialDetail !== undefined) return value.orderMaterialDetail.infoReceived === true || value.orderMaterialDetail.fileName !== undefined
        else return false
      },
      getChange (value) {
        if (value !== undefined && value.fileName) return this.$weui.alert('请先删除文件')
      },
      uploadFile (e, item) {
        if (this.disAllowUploadOrDelete(item)) return this.$weui.alert('实物反馈信息成功，不允许上传！')
        let file = e.target.files[0]
        if (!file) return
        let orderMaterialDetailId = null
        if (item.orderMaterialDetail) {
          orderMaterialDetailId = item.orderMaterialDetail.orderMaterialDetailId
        }
        this.getBase64(file).then(resBase64 => {
          let params = {orderMaterialId: item.orderMaterial.orderMaterialId, orderMaterialExpressId: this.currentOrderMaterialExpressId, orderMaterialDetailId: orderMaterialDetailId, fileName: file.name, creator: this.customerName, creatorNo: this.customerNo, base64FileContent: resBase64}
          this.$weui.loading('上传中', 8000)
          this.gcapi('uploadOrderMaterialFile', JSON.stringify(params)).then((res) => {
            let uploadFile = JSON.parse(res.body.result)
            this.$set(item.orderMaterial, 'isChecked', true)
            this.$set(item, 'orderMaterialDetail', uploadFile)
            if (!this.currentOrderMaterialExpressId) {
              this.uploadAfterOrderMaterialExpressId = uploadFile.orderMaterialExpressId
            }
            this.$weui.loading('上传成功').hide()
          })
        })
      },
      getBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          let fileResult = ''
          reader.readAsDataURL(file)
          reader.onload = function () {
            fileResult = reader.result
          }
          reader.onerror = function (error) {
            reject(error)
          }
          reader.onloadend = function () {
            resolve(fileResult)
          }
        })
      },
      disAllowUploadOrDelete (item) {
        return item.orderMaterialDetail && item.orderMaterialDetail.infoReceived
      },
      removeFile (value) {
        let params = {orderMaterialDetailId: value.orderMaterialDetail.orderMaterialDetailId, deletedBy: this.customerName, deleteNo: this.customerNo}
        this.gcapi('removeUploadedOrderMaterialFile', JSON.stringify(params)).then((res) => {
          this.orderMaterialInfo.orderMaterial.forEach(material => {
            if (material.orderMaterial.orderMaterialId === value.orderMaterial.orderMaterialId) {
              this.$set(material.orderMaterialDetail, 'fileName', undefined)
              this.$set(material.orderMaterialDetail, 'fileSizeDisplay', undefined)
              this.$set(material.orderMaterialDetail, 'fileType', null)
              this.$set(material.orderMaterialDetail, 'filePath', null)
              this.$set(material.orderMaterialDetail, 'orderMaterialDetailId', null)
            }
          })
        })
      },
      onChange (index) {
        this.plain.forEach((item, i) => {
          this.plain[i] = (i === index)
        })
        this.$forceUpdate()
      },
      chooseExpress (value, index) {
        this.expressIndex = index
        this.expressName = value
      },
      copy () {
        const clipboard = new Clipboard('#tag-copy')
        clipboard.on('success', (e) => {
          this.$weui.toast('复制成功', 1500)
          clipboard.destroy() // 释放内存
        })
        clipboard.on('error', (e) => {
          this.$weui.topTips('该浏览器不支持自动复制')
          clipboard.destroy()
        })
      },
      showMiniProgramInComputerUsage () {
        this.$router.push({
          name: 'ComputerSideUsage'
        })
      },
      openShunFengProgram () {
        wx.miniProgram.navigateTo({
          url: '/pages/toShunFeng/toShunFeng'
        })
      },
      saveSampleDelivery () {
        if (this.plain[0] && !this.expressNo) return this.$weui.alert('请输入快递单号')
        let expressNo = '非快递寄送'
        let expressName = '非快递寄送'
        if (this.plain[0]) {
          expressNo = this.expressNo
          expressName = this.expressName
        }
        let checkedOrderMaterialIds = this.orderMaterialInfo.orderMaterial.filter(material => material.orderMaterial.isChecked === true).map(m => m.orderMaterial.orderMaterialId)
        let params = {orderMaterialIds: checkedOrderMaterialIds, orderNo: this.getOrderMaterialInfo[0].orderMaterial.orderNo, orderMaterialExpressId: this.currentOrderMaterialExpressId, expressNo: expressNo, expressName: expressName, operator: this.customerName, operatorNo: this.customerNo}
        this.$weui.loading('保存中')
        this.gcapi('createOrUpdateOrderMaterialExpressInfo', JSON.stringify(params)).then((res) => {
          this.$weui.loading().hide()
          this.orderMaterialInfo = JSON.parse(res.body.result)
          this.setIsCheckedOrderMaterial(this.orderMaterialInfo)
          this.$weui.toast('保存成功', 1500)
          if (this.fromType === EMKT.SAMPLE_DELIVERY_FORM_TYPE.fromAddSampleDelivery) {
            this.$router.go(-2)
          } else if (this.fromType === EMKT.SAMPLE_DELIVERY_FORM_TYPE.fromModifySampleDelivery) {
            this.$router.go(-1)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background-color: #fafafa;
  }

  .secondary-title {
    width: 117px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    align-self: flex-start;
    margin: 10px 0 0 25px;
  }

  .txt {
    font-size: 12px;
    color: rgba(88, 120, 250, 1);
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mod4 {
    width: 86%;
    height: 21px;
    justify-content: space-between;
    margin: 15px 0 10px 25px;
  }

  .goods-info-sheet {
    width: 100%;
    height: 67px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #EFEEF3;
    justify-content: center;
    align-items: flex-start;
    padding-left: 14px;
    position: relative;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
  }

  .sheet-content {
    width: 100%;
    height: 41px;
    display: flex;
    flex-direction: row;
  }

  label.label-checkbox input[type=checkbox]:checked+.item-media i.icon-form-checkbox, label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }

  input {
    border: none;
    background: rgba(250, 250, 250, 1);
  }

  .upload {
    height: 47px;
    background: #FAFAFA;
    border-radius: 3px;
    border: 1px solid #EFEEF3;
    width: 47px;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: -3px;
    right: 15px;
    position: absolute;
  }

  .upload-icon {
    width: 27px;
    height: 17px;
    align-self: center;
    margin-top: 9px;
  }

  .upload-word {
    display: block;
    overflow-wrap: break-word;
    font-size: 9px;
    white-space: nowrap;
    line-height: 13px;
    text-align: left;
    margin-top: 1px;
    margin-bottom: 7px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
  }

  .uplaod-input {
    display: block;
    position: absolute;
    opacity: 0;
    top: -4px;
    left: 0;
    height: 50px;
    width: 100%;
  }

  .outer1 {
    width: 36%;
    height: 40px;
    margin-left: 10px;
  }

  .word2 {
    z-index: 43;
    width: 45px;
    height: 21px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 15px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 21px;
    text-align: left;
    align-self: flex-start;
  }

  .txt4 {
    width: 136px;
    height: 19px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 19px;
    text-align: left;
  }

  .label2 {
    width: 44px;
    height: 40px;
    margin-top: 1px;
    right: 25px;
    position: absolute;
  }

  .icon5 {
    position: absolute;
    top: 6px;
    width: 16px;
    height: 16px;
    right: 15px;
  }

  .mod6 {
    width: 87%;
    overflow-wrap: break-word;
    text-align: justify;
    align-self: center;
    margin: 9px 25px 0px 25px;
    font-size: 0;
  }

  .info2 {
    font-size: 12px;
    color: rgba(146, 146, 146, 1);
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .address {
    height: 163px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    margin-top: 9px;
    width: 100%;
    justify-content: flex-start;
    padding-top: 9px;
    align-items: flex-end;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .wrap {
    width: 95%;
    height: 135px;
  }

  .box7 {
    width: 95%;
    height: 41px;
    justify-content: space-between;
  }

  .icon9 {
    z-index: 144;
    width: 12px;
    height: 17px;
    margin-top: 22px;
  }

  .address-content {
    width: 77%;
    height: 40px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .group2 {
    z-index: 152;
    height: 23px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    border: 1px solid rgba(88, 120, 250, 1);
    margin-top: 18px;
    width: 42px;
    justify-content: center;
  }

  .box8 {
    z-index: auto;
    width: 108px;
    height: 17px;
    justify-content: space-between;
    margin: 3px 0 0 22px;
  }

  .info4 {
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-right: 8px;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #EFEEF3;
    margin-top: 9px;
  }

  .box10 {
    z-index: auto;
    width: 95%;
    height: 44px;
    margin-top: 19px;
  }

  .outer4 {
    width: 45px;
    height: 44px;
  }

  .paragraph1 {
    width: 90%;
    height: 40px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 2px 0 2px 14px;
  }

  .delivery-icon {
    z-index: 156;
    height: 23px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    border: 1px solid rgba(88, 120, 250, 1);
    width: 42px;
    justify-content: center;
    margin: 10px 0 0 2px;
  }

  .tag {
    width: 42px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: center;
  }

  .delivery {
    z-index: 160;
    height: 34px;
    width: 34px;
    justify-content: flex-start;
    align-items: flex-start;
    position: absolute;
    left: -2px;
    top: -2px;
    padding: 2px 0 0 2px;
  }

  .btn-group {
    background: #5878FA;
    border-radius: 44px;
    padding: 1px;
    margin-top: 15px;
  }

  .info6 {
    z-index: 164;
    width: 22px;
    height: 22px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 9px;
    line-height: 13px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tab-title li {
    width: 70px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    margin-top: 3px;
    margin-left: -60px;
  }

  .tab-title .active {
    height: 27px;
    border-radius: 13.5px 13.5px 13.5px 13.5px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.28);
    width: 175px;
    justify-content: center;
    align-items: center;
    color: rgba(88, 120, 250, 1);
    margin-top: -0.5px;
  }

  .express-category {
    height: 33px;
    padding: 0 10px;
    font-size: 14px;
  }

  .express-block {
    width: 110%;
    flex-wrap: wrap;
    margin-top: 10px;
    display: flex;
    color: rgba(66, 66, 66, 1);
  }

  .express-block .active {
    border: 0.5px solid #5878FA;
    color: rgba(88, 120, 250, 1);
  }

  .express-content {
    height: 81px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 81px;
    position: relative;
    margin: 0 11px 10px 0;
  }

  .icon-express {
    width: 78px;
    height: 81px;
  }

  .express-font {
    position: absolute;
    left: 0;
    top: 55px;
    width: 81px;
    height: 21px;
    display: block;
    overflow-wrap: break-word;
    font-size: 12px;
    white-space: nowrap;
    line-height: 20px;
    text-align: center;
  }

  .block9 {
    height: 61px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    margin-top: 9px;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .bd4 {
    height: 40px;
    border-radius: 5px;
    background-color: rgba(250, 250, 250, 1);
    width: 87%;
    justify-content: center;
    align-items: flex-start;
    padding-left: 10px;
  }

  .word19 {
    width: 77%;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
  }

  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
    z-index: 100;
  }

  .footer-content {
    display: flex;
    align-items: center;
    align-self: center;
    flex-direction: row;
    background-color: #ffffff;
    width: 100%;
    height: 58px;
    padding: 0px 10px;
  }

  .save-btn {
    width: 100%;
    height: 34px;
    border-radius: 17px;
    line-height: 20px;
    color: #fff;
    background-color: rgba(88, 120, 250, 1);
    justify-content: center;
    text-align: center;
    position: relative;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .save-tag {
    color: #ffffff;
    font-size: 14px;
    margin-left: -15px;
    white-space: nowrap;
    line-height: 20px;
    text-align: center;
    position: absolute;
    margin-top: 7px;
  }
</style>



// WEBPACK FOOTER //
// AddSampleDeliverySheet.vue?d97cefa4